<p class="input-label"><span class="sort" *ngIf="!buttonsOnly">Sort by:</span><span class="sort-by"
          [ngClass]="{'active-sort' : currentSort === 'oldest'}"
          (click)="changeSort('oldest')">Oldest first</span> | <span class="sort-by"
          [ngClass]="{'active-sort' : currentSort === 'newest'}"
          (click)="changeSort('newest')">Newest first</span> | <span class="sort-by"
          [ngClass]="{'active-sort' : currentSort === 'name'}"
          (click)="changeSort('name')">Name</span></p>
